import React, {Component} from 'react';

// eslint-disable-next-line no-unused-vars
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ICHeader} from '@homeaway/react-ic-components';
import actions from '../../actions/actions';
import LandingPage from '../LandingPage/LandingPage';
import Footer from '../Footer/footer';
import heroExport from '../../static/hero.svg';
import documentation from '../../static/documentation.svg';
import metrics from '../../static/metrics.svg';
import testingTools from '../../static/testing-tools.svg';
import './styles.less';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
function mapStateToProps(state) {
    return state;
}

// eslint-disable-next-line no-unused-vars
function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch), dispatch};
}

@connect(mapStateToProps, mapDispatchToProps)
export default class PageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.actions.triggerEdapPageView();
    }

    render() {
        const {app, translations, actions: appActions} = this.props;
        const {
            loading,
            requestSubmitted,
            requestAccessError,
            appLinks,
            loginLink,
            isLoggedIn,
            footerData,
        } = app;

        const loginHref = isLoggedIn ? '/t/logout' : '/t/login';
        return (
            <div className="page-container">
                <ICHeader
                    navLinks={appLinks}
                    logInOut={{...loginLink, href: loginHref}}
                    feedback={{
                        label: translations['ic.feedback'],
                        referrer: '/t',
                        reportIssueUrl: '/t/api/reportIssue',
                    }}
                    translations={translations}
                />
                <LandingPage
                    loading={loading}
                    actions={appActions}
                    isLoggedIn={isLoggedIn}
                    appLinks={appLinks}
                    translations={translations}
                    requestSubmitted={requestSubmitted}
                    requestAccessError={requestAccessError}
                    heroExport={heroExport}
                    documentation={documentation}
                    testingTools={testingTools}
                    metrics={metrics}
                />
                {footerData && <Footer footerData={footerData} />}
            </div>
        );
    }
}

PageContainer.propTypes = {
    app: PropTypes.arrayOf(PropTypes.object),
    translations: PropTypes.string,
    actions: PropTypes.object,
};
